import type { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { AddOutlined, ListOutlined } from '@mui/icons-material'
import { ApiKeyGenerationModal } from '@/features/api-key-generation'
import { useDialog } from '@/common/hooks'
import { ApiKeysListModal } from './ApiKeysListModal'
import {
  actionButtonSx,
  actionGroupSx,
  buttonLabelSx,
  contentSx,
  iconSx,
  sectionDescriptionSx,
  sectionTitleSx,
} from './settingsSectionStyles'

export const ApiKeysSection: FC = () => {
  const generateModal = useDialog()
  const listModal = useDialog()

  return (
    <>
      <Box>
        <Typography variant="body1" sx={sectionTitleSx}>
          API Keys
        </Typography>
        <Box sx={contentSx}>
          <Typography variant="body2" sx={sectionDescriptionSx}>
            Generate API key to receive remote agent notifications.
          </Typography>
          <Box sx={actionGroupSx}>
            <Box
              component="button"
              onClick={listModal.open}
              sx={actionButtonSx}
              aria-label="View API keys"
            >
              <ListOutlined sx={iconSx} aria-hidden="true" />
              <Typography variant="body2" sx={buttonLabelSx}>
                View
              </Typography>
            </Box>
            <Box
              component="button"
              onClick={generateModal.open}
              sx={actionButtonSx}
              aria-label="Generate API key"
            >
              <AddOutlined sx={iconSx} aria-hidden="true" />
              <Typography variant="body2" sx={buttonLabelSx}>
                Generate
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <ApiKeyGenerationModal open={generateModal.isOpen} onClose={generateModal.close} />
      <ApiKeysListModal open={listModal.isOpen} onClose={listModal.close} />
    </>
  )
}
